export default {
  // 统计信息
  total: "共计",
  totalData: "条数据",

  // 表格列标题
  asset: "资产",
  tokenContractAddress: "代币合约地址",
  quantity: "数量",
  priceUSDT: "价格（USDT）",
  valueUSDT: "价值（USDT）",
  updateTime: "更新时间",

  // 提示信息
  priceTooltip: "代币价格为当前币种对应的USDT价格，价格数据每日更新",
  valueTooltip:
    "代币价值是根据代币价格计算得出，代币价值受多种因素影响实时变化，此处代币价值仅供参考",

  // 加载和状态
  loading: "拼命加载中",
  noData: "暂无数据",
  tooMuchData: "当前地址交易数据过度，仅支持输入发送方/接收方地址的条件查询",

  // 下载
  downloadDetails: "下载数据明细",
  downloadNote: "注：最多可下载1万条数据",
};
